import { render, staticRenderFns } from "./Recommend.vue?vue&type=template&id=ac42a9da&scoped=true&"
import script from "./Recommend.vue?vue&type=script&lang=ts&"
export * from "./Recommend.vue?vue&type=script&lang=ts&"
import style0 from "./Recommend.vue?vue&type=style&index=0&id=ac42a9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac42a9da",
  null
  
)

export default component.exports